"use client";

import { useEffect } from "react";
import type { UseFormReturn } from "@/services/forms";

import type { HubSpotClientContext } from "./hub-spot-client-context";

export function useSetHubSpotClientContextValues<V extends { context: HubSpotClientContext }>(form: UseFormReturn<V>) {
  useEffect(() => {
    const castedForm = form as unknown as UseFormReturn<{ context: HubSpotClientContext }>;

    castedForm.setValue("context.pageUri", window.location.href);
    castedForm.setValue("context.pageName", document.title);

    const cleanup = setTimeout(() => {
      castedForm.setValue("context.hutk", window.__hsUserToken);
    }, 3000);

    return () => {
      clearTimeout(cleanup);
    };
  }, [form]);
}
